var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dialog-base',{staticClass:"dialog-base--image-upload",on:{"close":_vm.close},scopedSlots:_vm._u([{key:"heading",fn:function(){return [_vm._v("Upload an image")]},proxy:true}])},[_c('image-upload-form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }